<template>
    <div class="checkout-result">
        <slot name="decoration"></slot>
        <h3>Success! Please check your email you will receive confirmation.</h3>
        <h4>{{ title }}</h4>
        <div class="row mt-5">
            <div class="col-md-6 finish-summary">
                <slot name="summary"></slot>
            </div>
            <div class="col-md-6 pickup-info">
                <template v-if="withPickup">
                    <h5>Pickup Address</h5>
                    <div v-html="data.info.additional_info.pickup_address"/>
                    <h5>Opening Hours</h5>
                    <div v-html="data.info.additional_info.opening_hours"/>
                </template>
                <div v-if="data.info.qr">
                    <QrcodeVue class="qr-code" :value="data.info.qr" :size="200" level="H"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
    name: "CheckoutResult",
    components: {QrcodeVue},
    props: {
        data: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            default: 'Success!'
        },
        withPickup: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style scoped>

</style>
